// extracted by mini-css-extract-plugin
module.exports = {"button":"PaymentForm_button__nXCKY","form":"PaymentForm_form__xLO4f","error":"PaymentForm_error__X1jvm","grid":"PaymentForm_grid__XE6El"};